/*
  km-konfigurator-anfrage.js · Kirchberger Metall
  Angebotsanfrage aus dem Konfigurator: Modal öffnen, Adresse aufnehmen, an n8n schicken.

  Bewusst eigenständig gehalten – diese Datei liest den Konfiguratorzustand aus dem
  Formular und die Anzeige aus dem DOM, statt in km-konfigurator.js hineinzugreifen.
  Der angezeigte Preis wird NICHT mitgeschickt: n8n rechnet serverseitig aus den
  Regeln nach (Manipulationsschutz).
*/
(function () {
  function init(root) {
    var sid = root.getAttribute('data-section-id');
    var form = document.getElementById('km-form-' + sid);
    var knopf = document.getElementById('km-quote-' + sid);
    var modal = document.getElementById('km-modal-' + sid);
    var anfrage = document.getElementById('km-quoteform-' + sid);
    if (!form || !knopf || !modal || !anfrage) return;

    var rulesEl = document.getElementById('km-rules-' + sid);
    var ctxEl = document.getElementById('km-ctx-' + sid);
    if (!rulesEl || !ctxEl) return;
    var R = JSON.parse(rulesEl.textContent);
    var CTX = JSON.parse(ctxEl.textContent);

    var zusammenfassung = document.getElementById('km-modal-konfig-' + sid);
    var fehlerfeld = document.getElementById('km-quoteerr-' + sid);
    var fertig = document.getElementById('km-quotedone-' + sid);
    var gesamtpreis = document.getElementById('km-total-' + sid);
    var warenkorbKnopf = document.getElementById('km-add-' + sid);
    var hinweis = document.getElementById('km-msg-' + sid);
    var lieferBlock = document.getElementById('km-liefer-' + sid);

    var geoeffnetUm = 0;
    var zuletztFokussiert = null;
    var laeuft = false;

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function wert(name) {
      var el = form.elements[name];
      if (!el) return '';
      if (el.length && el[0] && el[0].type === 'radio') {
        for (var i = 0; i < el.length; i++) if (el[i].checked) return el[i].value;
        return '';
      }
      return el.value;
    }
    function nachId(liste, id) {
      for (var i = 0; i < liste.length; i++) if (liste[i].id === id) return liste[i];
      return liste[0];
    }

    // Zustand aus dem Konfiguratorformular – dieselben Kürzel, die auch der
    // Deep-Link verwendet, damit n8n und Theme dieselbe Sprache sprechen.
    function konfiguration() {
      return {
        m: wert('material'),
        f: wert('farbe'),
        // Wunschfarbe und Öffnungsfunktion müssen mit. Ohne oe rechnete n8n die
        // Fenstergitter bis 16.09.2026 immer ohne den Schloss-Aufpreis von 180 €,
        // das Angebot lag dann unter dem Warenkorbpreis.
        fw: String(wert('farbe_wunsch') || '').trim(),
        oe: wert('oeffnung'),
        b: Number(wert('breite')),
        h: Number(wert('hoehe')),
        bf: wert('befestigung'),
        hl: wert('handlauf'),
        q: Number(wert('menge')) || 1,
        st: wert('set'),
        bm: String(wert('bemerkung') || '').trim()
      };
    }

    function uebersichtHtml(k) {
      var mat = nachId(R.material.optionen, k.m);
      var bef = nachId(R.befestigung.optionen, k.bf);
      var set = nachId(R.sets.optionen, k.st);
      var z = [];
      z.push(R.material.label + ': ' + mat.label);
      if (mat.farbe && k.f) z.push(R.farbe.label + ': ' + k.f);
      z.push(R.befestigung.label + ': ' + bef.label);
      z.push(R.breite.label + ': ' + k.b + ' mm');
      z.push(R.hoehe.label + ': ' + k.h + ' mm');
      if (k.hl) z.push(R.handlauf.label + ': ' + k.hl);
      if (R.oeffnung && k.oe) {
        var oe = nachId(R.oeffnung.optionen, k.oe);
        // Abgewaehlte Oeffnung ("Ohne") steht nicht im Anfragetext (Martin 22.09.2026). Der Wert k.oe
        // bleibt in der Konfiguration - n8n braucht ihn zum Rechnen.
        if (oe.id !== 'ohne') {
          z.push((R.oeffnung.label || R.oeffnung.key) + ': ' + oe.label);
          // Ab 1500 mm Laibungshoehe zwei Schloesser (rules.oeffnung.schloesser, 09.10.2026)
          var sl = R.oeffnung.schloesser;
          if (sl) z.push('Anzahl Schlösser: ' + (Number(k.h) >= Number(sl.ab_hoehe) ? sl.anzahl_ab : sl.anzahl_unter));
        }
      }
      z.push(R.sets.label + ': ' + set.label);
      var preis = gesamtpreis ? gesamtpreis.textContent.trim() : '';
      var fuss = k.q + (k.q === 1 ? ' Stück' : ' Stück');
      if (preis && preis !== '–') fuss += ' · ' + preis + ' inkl. MwSt.';
      return z.map(esc).join('<br>') + '<br><br><strong>' + esc(fuss) + '</strong>';
    }

    function fokussierbare() {
      return modal.querySelectorAll('button:not([disabled]),a[href],input:not([type="hidden"]),select,textarea');
    }
    function beiTaste(e) {
      if (e.key === 'Escape') { schliessen(); return; }
      if (e.key !== 'Tab') return;
      var f = fokussierbare(); if (!f.length) return;
      var erstes = f[0], letztes = f[f.length - 1];
      if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
      else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
    }

    function oeffnen() {
      // Der Warenkorb-Knopf ist genau dann gesperrt, wenn die Maße nicht stimmen.
      if (warenkorbKnopf && warenkorbKnopf.disabled) {
        if (hinweis) {
          hinweis.textContent = 'Bitte prüfen Sie die Maße, bevor Sie ein Angebot anfordern.';
          hinweis.className = 'km-msg is-err';
        }
        return;
      }
      var k = konfiguration();
      zusammenfassung.innerHTML = uebersichtHtml(k);

      // Anmerkung aus dem Konfigurator übernehmen, sofern im Modal noch nichts steht
      var bem = wert('bemerkung');
      if (bem && !anfrage.elements['bemerkung'].value) anfrage.elements['bemerkung'].value = bem;

      // Land aus dem Shopify-Markt vorbelegen, wenn es freigegeben ist
      if (CTX.country) {
        var landFeld = anfrage.elements['land'];
        for (var i = 0; i < landFeld.options.length; i++) {
          if (landFeld.options[i].value === CTX.country) { landFeld.value = CTX.country; break; }
        }
      }

      ustidSichtbarkeit();

      anfrage.hidden = false;
      fertig.hidden = true;
      fehlerfeld.hidden = true;
      modal.hidden = false;
      document.body.classList.add('km-modal-open');
      document.addEventListener('keydown', beiTaste);
      geoeffnetUm = Date.now();
      zuletztFokussiert = document.activeElement;
      var erstesFeld = anfrage.querySelector('input[name="vorname"]');
      if (erstesFeld) erstesFeld.focus();
    }

    function schliessen() {
      modal.hidden = true;
      document.body.classList.remove('km-modal-open');
      document.removeEventListener('keydown', beiTaste);
      if (zuletztFokussiert && zuletztFokussiert.focus) zuletztFokussiert.focus();
    }

    function fehler(text) {
      fehlerfeld.textContent = text;
      fehlerfeld.hidden = false;
      fehlerfeld.scrollIntoView({ block: 'nearest' });
    }

    function adresse() {
      var fehlend = [];
      ['vorname', 'nachname', 'strasse', 'plz', 'ort', 'email'].forEach(function (n) {
        var el = anfrage.elements[n];
        var leer = !String(el.value || '').trim();
        el.setAttribute('aria-invalid', leer ? 'true' : 'false');
        if (leer) fehlend.push(n);
      });
      if (fehlend.length) {
        fehler('Bitte füllen Sie alle Pflichtfelder aus.');
        anfrage.elements[fehlend[0]].focus();
        return null;
      }

      var mail = String(anfrage.elements['email'].value).trim();
      if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(mail)) {
        anfrage.elements['email'].setAttribute('aria-invalid', 'true');
        fehler('Diese E-Mail-Adresse sieht nicht richtig aus. Ohne sie können wir Ihnen das Angebot nicht schicken.');
        anfrage.elements['email'].focus();
        return null;
      }
      // Kein Einwilligungs-Haken mehr (Martin 16.09.2026) - der Datenschutzhinweis steht unter dem
      // Formular. Die Nutzlast fuehrt dsgvo weiterhin als true: der n8n-Workflow bricht ohne dieses
      // Feld ab (Node "Anfrage pruefen": if (b.dsgvo !== true) throw).
      // Anrede entfaellt: der Workflow hat dafuer einen Fallback ("Guten Tag Vorname Nachname").
      function t(n) { var el = anfrage.elements[n]; return el ? String(el.value || '').trim() : ''; }
      return {
        firma: t('firma'), ustid: t('ustid').toUpperCase().replace(/[\s.\-]/g, ''),
        vorname: t('vorname'), nachname: t('nachname'),
        strasse: t('strasse'), plz: t('plz'), ort: t('ort'),
        land: t('land') || 'DE', email: mail,
        telefon: t('telefon'), bemerkung: t('bemerkung')
      };
    }

    // Abweichende Lieferanschrift: nur pruefen, wenn der Haken gesetzt ist.
    // Ansprechpartner und Telefon sind Pflicht - die Spedition avisiert telefonisch.
    function lieferanschrift() {
      var an = anfrage.elements['abw_lieferung'];
      if (!an || !an.checked) return { ok: true, wert: null };

      var fehlend = [];
      ['l_person', 'l_telefon', 'l_strasse', 'l_plz', 'l_ort'].forEach(function (n) {
        var el = anfrage.elements[n];
        if (!el) return;
        var leer = !String(el.value || '').trim();
        el.setAttribute('aria-invalid', leer ? 'true' : 'false');
        if (leer) fehlend.push(n);
      });
      if (fehlend.length) {
        fehler('Bitte fuellen Sie die Lieferanschrift vollstaendig aus. Ansprechpartner und Telefon brauchen wir fuer die Avisierung durch die Spedition.');
        anfrage.elements[fehlend[0]].focus();
        return { ok: false, wert: null };
      }

      function lt(n) {
        var el = anfrage.elements[n];
        return el ? String(el.value || '').trim() : '';
      }
      return {
        ok: true,
        wert: {
          firma: lt('l_firma'),
          person: lt('l_person'),
          telefon: lt('l_telefon'),
          strasse: lt('l_strasse'),
          plz: lt('l_plz'),
          ort: lt('l_ort'),
          land: lt('l_land') || 'DE'
        }
      };
    }

    // Lieferblock ein- und ausblenden. Beim Zuklappen die Felder leeren, damit keine
    // halb ausgefuellte Anschrift mitgeschickt wird.
    var abwFeld = anfrage.elements['abw_lieferung'];
    if (abwFeld && lieferBlock) {
      abwFeld.addEventListener('change', function () {
        lieferBlock.hidden = !abwFeld.checked;
        if (!abwFeld.checked) {
          ['l_firma', 'l_person', 'l_telefon', 'l_strasse', 'l_plz', 'l_ort'].forEach(function (n) {
            var el = anfrage.elements[n];
            if (el) { el.value = ''; el.setAttribute('aria-invalid', 'false'); }
          });
        } else {
          var erstes = anfrage.elements['l_person'];
          if (erstes) erstes.focus();
        }
      });
    }

    knopf.addEventListener('click', oeffnen);
    modal.querySelectorAll('[data-km-close]').forEach(function (b) {
      b.addEventListener('click', schliessen);
    });

    // USt-IdNr. ist nur fuer Firmenkunden aus dem EU-Ausland relevant - Feld daher nur
    // einblenden, wenn ein anderes Land als Deutschland gewaehlt ist.
    function ustidSichtbarkeit() {
      var feld = anfrage.querySelector('.km-fld--ustid');
      var landFeld = anfrage.elements['land'];
      if (!feld || !landFeld) return;
      var auslaendisch = landFeld.value && landFeld.value !== 'DE';
      feld.hidden = !auslaendisch;
      if (!auslaendisch && anfrage.elements['ustid']) anfrage.elements['ustid'].value = '';
    }
    if (anfrage.elements['land']) anfrage.elements['land'].addEventListener('change', ustidSichtbarkeit);

    anfrage.addEventListener('submit', function (e) {
      e.preventDefault();
      if (laeuft) return;
      fehlerfeld.hidden = true;

      var kunde = adresse();
      if (!kunde) return;

      var liefer = lieferanschrift();
      if (!liefer.ok) return;

      if (!CTX.quoteEndpoint) {
        fehler('Die Anfrage kann gerade nicht übermittelt werden. Bitte rufen Sie uns an: +49 9672 9269 110');
        return;
      }

      var absenden = anfrage.querySelector('button[type="submit"]');
      laeuft = true;
      absenden.setAttribute('aria-busy', 'true');

      var nutzlast = {
        produkt_id: String(CTX.productId || ''),
        produkt_titel: CTX.productTitle,
        sku: CTX.sku || '',
        hp: String(anfrage.elements['hp'].value || ''),
        ms: Date.now() - geoeffnetUm,
        dsgvo: true,
        // Der Fertigungsstart steht nicht in der Konfiguration, gehört aber in den
        // Auftrag: die Werkstatt darf nicht auf eine Freigabe warten, die der Kunde
        // bewusst abgewählt hat.
        fertigungsstart: wert('fertigungsstart') || 'sofort',
        kunde: kunde,
        lieferung: liefer.wert,
        konfig: konfiguration()
      };

      fetch(CTX.quoteEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(nutzlast)
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (j) { return { ok: res.ok, body: j }; });
        })
        .then(function (a) {
          if (!a.ok || a.body.ok !== true) throw new Error(a.body && a.body.grund ? a.body.grund : '');
          anfrage.hidden = true;
          fertig.hidden = false;
          fertig.querySelector('button').focus();
        })
        .catch(function (e) {
          fehler((e.message ? e.message + ' ' : 'Die Anfrage konnte nicht übermittelt werden. ') +
            'Bitte versuchen Sie es noch einmal oder rufen Sie uns an: +49 9672 9269 110');
        })
        .then(function () {
          laeuft = false;
          absenden.removeAttribute('aria-busy');
        });
    });
  }

  document.querySelectorAll('.km-konfform[data-section-id], .km-konf[data-section-id]').forEach(init);
})();
